package es.cragma.fichajefacil.ui.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

// Cragma Dark Blue Palette
val CragmaNavyDark = Color(0xFF0D1B2A)      // Primary dark background / header
val CragmaNavyMedium = Color(0xFF1B263B)    // Card surface & dialogs
val CragmaNavyLight = Color(0xFF415A77)     // Borders & muted accents
val CragmaBlueAccent = Color(0xFF2563EB)    // Vibrant blue highlight
val CragmaBlueSoft = Color(0xFF3B82F6)

// Action & Status Colors
val CragmaRedDanger = Color(0xFFE63946)     // Stop shift / Delete / Alerts
val CragmaRedDark = Color(0xFFC1121F)
val CragmaGreenSuccess = Color(0xFF10B981)  // Clocked in status / Start shift
val CragmaAmberWarning = Color(0xFFF59E0B)  // On break / Unverified location badge

// Neutral & Backgrounds
val CragmaBgLight = Color(0xFFF8FAFC)       // Soft modern light background
val CragmaSurfaceLight = Color(0xFFFFFFFF)  // White card surface
val CragmaTextPrimary = Color(0xFF0F172A)
val CragmaTextSecondary = Color(0xFF64748B)

private val DarkColorScheme = darkColorScheme(
    primary = CragmaBlueSoft,
    onPrimary = Color.White,
    primaryContainer = CragmaNavyMedium,
    onPrimaryContainer = Color.White,
    secondary = CragmaNavyLight,
    onSecondary = Color.White,
    background = CragmaNavyDark,
    onBackground = Color.White,
    surface = CragmaNavyMedium,
    onSurface = Color.White,
    error = CragmaRedDanger,
    onError = Color.White
)

private val LightColorScheme = lightColorScheme(
    primary = CragmaNavyDark,
    onPrimary = Color.White,
    primaryContainer = CragmaNavyMedium,
    onPrimaryContainer = Color.White,
    secondary = CragmaBlueAccent,
    onSecondary = Color.White,
    background = CragmaBgLight,
    onBackground = CragmaTextPrimary,
    surface = CragmaSurfaceLight,
    onSurface = CragmaTextPrimary,
    surfaceVariant = Color(0xFFE2E8F0),
    onSurfaceVariant = CragmaTextSecondary,
    error = CragmaRedDanger,
    onError = Color.White
)

@Composable
fun FichajeFacilTheme(
    darkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit
) {
    val colorScheme = if (darkTheme) DarkColorScheme else LightColorScheme

    MaterialTheme(
        colorScheme = colorScheme,
        content = content
    )
}
